import { useMemo } from 'react';
import Dropdown from '../shared/Dropdown';

export default function QuestionFilters({
  searchTerm,
  setSearchTerm,
  selectedProduct,
  setSelectedProduct,
  selectedCategory,
  setSelectedCategory,
  products = [],
  categories = []
}) {
  // Transform products API data into dropdown options
  const productOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Products' },
      ...products.map(product => ({
        value: product.id,
        label: product.name
      }))
    ];
  }, [products]);

  // Transform categories API data into dropdown options
  const categoryOptions = useMemo(() => {
    return [
      { value: 'all', label: 'All Categories' },
      ...categories.map(category => ({
        value: category,
        label: category
      }))
    ];
  }, [categories]);

  const clearAll = () => {
    setSearchTerm('');
    setSelectedProduct('all');
    setSelectedCategory('all');
  };

  const hasActiveFilters = searchTerm || selectedProduct !== 'all' || selectedCategory !== 'all';

  return (
    <div className="space-y-3">
      {/* Search Bar */}
      <div className="relative">
        <svg
          className="absolute left-3 top-1/2 transform -translate-y-1/2 w-5 h-5 text-gray-400"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
        </svg>
        <input
          type="text"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          placeholder="Search questions..."
          className="w-full pl-10 pr-4 py-2 bg-gray-800 border border-gray-700 rounded-lg text-white text-sm focus:outline-none focus:border-purple-500"
        />
      </div>

      {/* Dropdowns Row */}
      <div className="grid grid-cols-2 gap-2">
        <Dropdown
          value={selectedProduct}
          onChange={(e) => setSelectedProduct(e.target.value)}
          options={productOptions}
          className="!pl-3"
        />

        <Dropdown
          value={selectedCategory}
          onChange={(e) => setSelectedCategory(e.target.value)}
          options={categoryOptions}
          className="!pl-3"
        />
      </div>

      {/* Clear All Button */}
      {hasActiveFilters && (
        <div className="flex justify-end">
          <button
            onClick={clearAll}
            className="text-xs text-purple-400 hover:text-purple-300 transition-colors duration-200 underline"
          >
            Clear All
          </button>
        </div>
      )}
    </div>
  );
}
